<template>
  <div class="bg-white flex flex-col items-center py-20px mt-50px text-gray-500 text-sm">
    <div class="hidden lg:flex items-center mb-10px">
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/index"
        class="px-2 leading-none border-r border-gray-500 hover:text-tax-6"
        >About YorkBBS</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/aboutus"
        class="px-2 leading-none border-r border-gray-500 hover:text-tax-6"
        >关于我们</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/ads"
        class="px-2 leading-none border-r border-gray-500 hover:text-tax-6"
        >广告服务</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/concat"
        class="px-2 leading-none border-r border-gray-500 hover:text-tax-6"
        >联系方式</a
      >
      <a href="mailto:marketing@yorkbbs.ca" class="px-2 leading-none border-r border-gray-500 hover:text-tax-6"
        >媒体合作</a
      >
      <a
        target="_blank"
        href="//corp.yorkbbs.ca/policy"
        class="px-2 leading-none border-r border-gray-500 hover:text-tax-6"
        >免责声明</a
      >
      <a target="_blank" href="//corp.yorkbbs.ca/maps" class="px-2 leading-none hover:text-tax-6">网站导航</a>
    </div>
    <div class="flex items-center">
      <div class="px-10px hidden lg:block">广告热线：416-628-9108</div>
      <div class="px-10px hidden lg:block">
        广告邮件：<a href="mailto:info@yorkbbs.ca" class="hover:text-tax-6">info@yorkbbs.ca</a>
      </div>
      <div class="px-10px text-center">
        Copyright © 2002-{{ newYear }} <span class="block lg:inline-block">Yorkbbs.ca 约克论坛 版权所有</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FooterWhite',
  data() {
    return {
      newYear: new Date().getFullYear(),
    };
  },
};
</script>
